import { Component, Input, OnInit } from '@angular/core';
import { CPMemberService } from '../../services/CPMember.service';
import { SelfMember } from 'src/app/cp-member/models/self-member.model';
import { Policy } from '../../models/policy.model';
import { HRProfile } from '../../models/hr.profile.model';
import { PolicyInfoModel } from '../../models/policy-Info.model';
import { NumberFormatPipe } from 'src/app/shared/pipes/number-format.pipe';
import { CPPolicyService } from 'src/app/corporate-portal/services/cp-policy.service';
import { CPWellnessService } from '../../services/CPWellness.service';
import { PolicyAllowedSumInsured } from 'src/app/cp-member/models/policy-suminsured.model';
import moment from 'moment';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { EncruptioDecryptionService } from 'src/app/shared/services/encryption-decryption.service';
import { TrackingService } from 'src/app/Tracking.service';

@Component({
  selector: 'app-cp-member-profile',
  templateUrl: './cp-member-profile.component.html',
  styleUrls: ['./cp-member-profile.component.scss'],
})
export class CpMemberProfileComponent implements OnInit {
  @Input() noNomineeAdded = false;
  policies = [];
  policyNumber: any;
  currentPolicy: Policy;
  isHr: boolean;
  isMember: boolean;
  isHrView = false;
  policyAllowedSumInsureds: PolicyAllowedSumInsured[] = [];
  coveredUptoSumInsured: number;
  memberAge: any;
  memberDoj: any;
  showModal = false;
  policyInfo: PolicyInfoModel = new PolicyInfoModel();
  isPolicyInfoLoaded = false;
  isNomineeAvailable = false;
  hrProfile: HRProfile = new HRProfile();
  ishrProfileLoaded = false;
  family;
  adultCount = 0;
  childrenCount = 0;
  memberSelf: SelfMember = new SelfMember();
  ismemberLoaded = false;
  isDependentLoaded = false;
  isNomineeLoaded = false;
  employeeId = "";

  isEmployeeBelongsToPolicy = false;
  dependent: SelfMember[] = [];
  nominee: any[] = [];
  rhealthAssist: string;
  rhealthCircle: string;

  isMobileView: boolean = false;

  base64Str: string | ArrayBuffer | null = null;
  showECardPreview: boolean = false;

  productCode: string = "";
  iframeSrc: SafeResourceUrl;
  isEcardDownloading: boolean = false;

  memberToEmail = new SelfMember();
  email: string;
  isEmailSent = false;
  invalidEmail = false;
  invalidEmailMsg: string;
  errorOccuredViaEmail = false;

  constructor(
    private policyService: CPPolicyService,
    private cpWellnessService: CPWellnessService,
    private cpMemberService: CPMemberService,
    private readonly alertService: AlertService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private router: Router,
    private encryptDecrypt: EncruptioDecryptionService,
    private tracking: TrackingService


  ) {}

  async ngOnInit() {
    if(window.innerWidth < 576){
      this.isMobileView = true;
    }
    this.memberSelf = new SelfMember();

    this.cpMemberService.isHrView.subscribe(v => {
      this.isHrView = v;
    });

    this.policyService.policies.subscribe(policies => {
      this.policies = policies;
      policies.forEach(async policy => {
        if (policy.isActive && policy.policyType === 'IPD/OPD') {
          this.currentPolicy = policy;
          this.policyNumber = this.currentPolicy.policyNumber;
          this.isHr = this.cpMemberService.isHr;
          this.isMember = this.cpMemberService.isMember;
          this.isPolicyInfoLoaded = false;
          this.ismemberLoaded = false;
          //extract the product code
          this.productCode = this.policyNumber.substring(7, 11);

          this.isEmployeeBelongsToPolicy = this.currentPolicy.isMemberEnrolled;
          if (this.policyNumber !== undefined && this.isHr === true && this.isHrView) {
            this.cpMemberService.hrDetails.subscribe(hr => {
              this.hrProfile = hr;
              this.ishrProfileLoaded = true;

              this.calculateAge(this.hrProfile.dob);
              this.calculateDoj(this.hrProfile.doj);
            });

            await this.cpMemberService
              .getPolicyInfo(this.policyNumber)
              .then(x => {
                this.policyInfo = x;
                const numberFormatPipe1 = new NumberFormatPipe();
                this.policyInfo.activeInsured = numberFormatPipe1.transform(this.policyInfo.activeInsured);
                this.policyInfo.totalEndorsements = numberFormatPipe1.transform(this.policyInfo.totalEndorsements);
                this.policyInfo.cashlessClaims = numberFormatPipe1.transform(this.policyInfo.cashlessClaims);
                this.policyInfo.reimbursementClaims = numberFormatPipe1.transform(this.policyInfo.reimbursementClaims);
                this.isPolicyInfoLoaded = true;
              })
              .catch(x => {
                // console.log('error');
              });

            await this.cpMemberService
              .getPolicyAllowedSumInsured(this.policyNumber)
              .then(x => {
                this.policyAllowedSumInsureds = x;
                const SI = this.policyAllowedSumInsureds.map(x => x.sumInsured);
                if (!SI.length) {
                  this.coveredUptoSumInsured = 0;
                } else {
                  this.coveredUptoSumInsured = Math.max.apply(null, SI);
                }
              })
              .catch(x => {
                this.policyAllowedSumInsureds = null;
                this.coveredUptoSumInsured = 0;
                // console.log('error');
              });
          }
          this.adultCount = 0;
          this.childrenCount = 0;
          this.cpMemberService
            .getMemberFamily(this.policyNumber)
            .then(x => {
              // console.log(x);
              this.family = x;
              if (!(this.adultCount + this.childrenCount === this.family.length)) {
                x.forEach(element => {
                  if (element.age >= 18) this.adultCount++;
                  else this.childrenCount++;
                });
              }
            })
            .catch(x => {
              // console.log('error');
            });
          if (this.policyNumber !== undefined && this.isMember === true && this.currentPolicy.isMemberEnrolled) {
            this.cpMemberService.getMemberFamily(this.policyNumber).then(f => {
              this.family = f;
              this.family.forEach(member => {
                if(member.relationShipId?.toLowerCase() === 'self'){
                  this.memberSelf = member;
                }
              });
              if (this.productCode == '2958') {
                this.employeeId = this.memberSelf.memberIdEmpId;
                this.cpMemberService
                  .getNomineeDetails(this.policyNumber, this.employeeId)
                  .then(n => {
                    this.isNomineeAvailable = true;
                    this.isNomineeLoaded = true;
                    n['age'] = this.calculateAge(n.dob);
                    this.nominee = [n];
                  })
                  .catch(n => {
                    this.isNomineeLoaded = true;
                    this.isNomineeAvailable = false;
                  });
              }
              this.ismemberLoaded = JSON.stringify(this.memberSelf) === '{}' ? false : true;
            });

            this.cpMemberService.dependentDetails.subscribe(d => {
              this.dependent = d;
              this.isDependentLoaded = JSON.stringify(this.memberSelf) === '{}' ? false : true;
            });
            if (policy.wellness) {
              if (policy.rHealthAssist) {
                this.cpWellnessService.getRhealthAssist(policy.policyNumber).then(x => {
                  this.rhealthAssist = x.url;
                });
              }
              if (policy.rHealthCircle) {
                this.cpWellnessService.getRhealthCircle(policy.policyNumber).then(x => {
                  this.rhealthCircle = x.url;
                });
              }
            }
          }
        }
      });
    });
  }

  calculateAge(dob) {
    if (dob) {
      const memberDOB = moment(dob).format('L');
      const age = Math.floor((new Date().valueOf() - new Date(memberDOB).getTime()) / 3.15576e10);
      this.memberAge = age;
      return age;
    }
  }

  calculateDoj(doj) {
    if (doj) {
      this.memberDoj = doj === '0001-01-01T00:00:00' ? 'NA' : this.formatDate(new Date(doj));
    }
  }

  formatDate(date) {
    const day = date.getDate().toString().length === 2 ? date.getDate() : '0' + date.getDate().toString();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    let ddate;
    if (month.toString().length === 1) {
      ddate = day + '-0' + month + '-' + year;
    } else {
      ddate = day + '-' + month + '-' + year;
    }
    return ddate;
  }

  formatDoj(doj) {
    return this.formatDate(new Date(doj));
  }

  onNamePolicyChanged(policy) {
    this.policyService.currentPolicy.next(policy);
  }

  showEcard(){
    this.cpMemberService.getECards(this.policyNumber, this.memberSelf.uhid).then(x => {
      const blob = new Blob([x], {type: 'application/pdf'});
      this.base64Str = URL.createObjectURL(blob);
      this.showECardPreview = true;
    }).catch(error => {
      // console.log(error);
    })
  }


  downloadECard(){
    this.isEcardDownloading = true;
    this.tracking.pushEvent("download_ecard", {});

    this.policies.forEach(pol => {
      if (pol.isActive && pol.policyType === 'IPD/OPD') {
        this.cpMemberService
          .getECards(this.policyNumber, this.memberSelf.uhid)
          .then(x => {
            const blob = new Blob([x], { type: 'application/pdf' });
            this.downloadPDF(blob);
            this.isEcardDownloading = false;
            return;
          })
          .catch(error => {
            // console.log(error);
            this.isEcardDownloading = false;
            this.alertService.error('E card download failed');
            return;
          });
      }
    });
  }

  downloadPDF(file: any){
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.target = "_blank";
    link.click();
    this.alertService.success("E card downloaded successfully");
  }

  navigateToPolicyCoverage(){
    this.tracking.pushEvent("policy_benefit_click", {});
    this.router.navigate(['cp-member/policy-coverage']);
  }

  navigateToNetworkHospitals() {
    this.tracking.pushEvent("hospital_network", {});
    // this.router.navigate(['cp-member/network-hospitals']);
  }

  redirectToAddNominee() {
    this.router.navigate(['/cp-member/add-nominee']);
  }

  emailEcard(member) {
    this.tracking.pushEvent("share_ecard", {});
    this.isEmailSent = null;
    this.memberToEmail = this.memberSelf;
    this.email = this.memberSelf.emailID;
    this.invalidEmail = false;
    this.invalidEmailMsg = '';
  }

  emailSubmit() {
    if (this.ismemberLoaded) {
      const email = this.encryptDecrypt.encrypt(this.email, `${this.memberToEmail.uhid}KPngPNGyVN`);

      this.isEmailSent = false;
      this.cpMemberService
        .emailECards(this.policyNumber, this.memberToEmail.uhid, email)
        .then(x => {
          this.isEmailSent = true;
          this.errorOccuredViaEmail = false;
        })
        .catch(x => {
          // console.log('error');
          this.errorOccuredViaEmail = true;
          this.isEmailSent = false;
        });
    }
  }

  
  emailInput(event) {
    const email = event.target.value;
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/i.test(email)) {
      this.invalidEmail = false;
      this.invalidEmailMsg = '';
    } else if (/^\w+([\.-]?\w+)*@arteras.engineering+$/i.test(email)) {
      this.invalidEmail = false;
      this.invalidEmailMsg = '';
    } else {
      this.invalidEmail = true;
      this.invalidEmailMsg = 'Please enter valid Email Id';
    }
  }
}
